import QuestCard from "./QuestCard";

/**
 * @typedef {import("../../../../hooks/teacher/quest/useGetQuestByCategory").QuestType} QuestType
 */
/**
 * @param {{quests: QuestType[] , questType: string}} param0 
 * @returns 
 */
const QuestCards = ({ quests, questType }) => {
  return (
    <div className="">
      <div className="quest-card-title-container">
        <div className="quest-card-title-icon"></div>
        <h2 className="quest-card-title">{questType}</h2>
      </div>
      <div className="quest-cards-container">
        {quests.map((quest) => (
          <QuestCard key={quest.id} quest={quest} />
        ))}
      </div>
    </div>
  );
};
export default QuestCards;

